<template>
  <div>
  <div class="PaymentRecord">
    <div class="header">
      <span :style="{marginLeft: '20px'}"><svg data-v-295f3a3b="" width="48" height="40" viewBox="0 0 48 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path data-v-295f3a3b="" d="M47.4468 25.1025C47.4468 21.3412 42.3298 18.3947 36.0597 18.3947C35.6425 18.3947 35.1408 18.4094 34.7358 18.4353V7.45901C34.794 7.18123 34.7725 6.89856 34.7725 6.61002C34.7725 2.9035 30.0145 0 23.7449 0C17.4748 0 12.5637 2.90399 12.5637 6.61002C12.5637 6.89856 12.6033 7.18074 12.6615 7.45901V10.4686C12.3079 10.4496 11.949 10.4378 11.5846 10.4378C5.3145 10.4378 0.494898 13.3408 0.494898 17.0474C0.494898 17.3364 0.443059 17.6186 0.501256 17.8968V33.2697H0.577548C0.774636 36.7737 5.53115 39.4899 11.5846 39.4899C17.6337 39.4899 22.6934 36.7781 22.8974 33.2697H22.9732V32.6295C23.3312 32.6505 23.3761 32.6838 23.7444 32.6838C24.1625 32.6838 24.5714 32.6662 24.9758 32.6398V32.8207H25.0575L25.034 33.2398C25.034 36.853 29.949 40 36.223 40C42.498 40 47.4125 37.1268 47.4125 33.4521L47.4003 33.0349H47.4707V25.9642C47.5304 25.682 47.4468 25.3959 47.4468 25.1025ZM36.2235 20.527C41.7395 20.527 45.5835 22.938 45.5835 25.1025C45.5835 27.2666 41.7395 29.6781 36.2235 29.6781C30.708 29.6781 26.8636 27.2671 26.8636 25.1025C26.8636 22.938 30.7075 20.527 36.2235 20.527ZM45.6828 28.8531V30.0106C45.1556 32.3278 40.9629 34.2654 36.223 34.2654C31.4866 34.2654 27.2944 32.3292 26.7638 30.0145V28.8531C28.7797 30.6488 32.2289 31.8103 36.223 31.8103C40.2181 31.8103 43.6674 30.6484 45.6828 28.8531ZM23.7449 19.52C23.381 19.52 23.3282 19.5043 22.9732 19.4814V17.8963C23.0094 17.7242 23.0338 17.5501 23.0509 17.3745C23.3791 17.3941 23.406 17.4063 23.7449 17.4063C27.7175 17.4063 30.9755 16.2336 32.9131 14.4373V15.3278C32.3933 17.6107 28.4143 19.52 23.7449 19.52ZM33.0662 18.6324C32.9043 18.6583 32.7415 18.6818 32.5825 18.7111C32.7464 18.582 32.919 18.4563 33.0662 18.3199V18.6324ZM23.7449 2.10194C29.1802 2.10194 32.8143 4.47775 32.8143 6.61051C32.8143 8.74277 29.1797 11.1186 23.7444 11.1186C18.3091 11.1186 14.5214 8.74277 14.5214 6.61051C14.5219 4.47775 18.3096 2.10194 23.7449 2.10194ZM14.4236 10.3053C14.5923 10.4559 14.785 10.5953 14.9742 10.7361C14.7943 10.7034 14.6075 10.6799 14.4236 10.6525V10.3053ZM11.5846 12.5388C17.0199 12.5388 20.9607 14.9151 20.9607 17.0474C20.9607 19.1801 17.0199 21.5554 11.5846 21.5554C6.14931 21.5554 2.36161 19.1801 2.36161 17.0474C2.36161 14.9151 6.14931 12.5388 11.5846 12.5388ZM2.26331 20.7431C4.24983 22.5125 7.64874 23.6569 11.5846 23.6569C15.5205 23.6569 19.0725 22.512 21.0585 20.7431V21.8836C20.5392 24.1665 16.2546 26.0757 11.5846 26.0757C6.91712 26.0757 2.78659 24.1679 2.26331 21.8865V20.7431V20.7431ZM2.26331 24.8776C4.20044 26.6719 7.61157 27.8441 11.5846 27.8441C15.5572 27.8441 19.1219 26.6714 21.0585 24.8751V25.7647C20.5392 28.0481 16.2546 29.9568 11.5846 29.9568C6.91712 29.9568 2.78659 28.0495 2.26331 25.7681V24.8776V24.8776ZM2.26331 28.7596C4.20044 30.5545 7.61157 31.7262 11.5846 31.7262C15.5572 31.7262 19.1219 30.554 21.0585 28.7572V29.6468C20.5392 31.9302 16.2546 33.8394 11.5846 33.8394C6.91712 33.8394 2.78659 31.9321 2.26331 29.6502V28.7596V28.7596ZM11.5846 37.721C6.7396 37.721 2.48338 35.665 2.23005 33.2697H2.26331V32.6412C4.20044 34.4351 7.61157 35.6073 11.5846 35.6073C15.5572 35.6073 19.1219 34.4346 21.0585 32.6393V33.2692H21.0913C20.838 35.6646 16.4292 37.721 11.5846 37.721ZM22.802 15.59C22.4328 14.5864 21.3852 13.6758 20.3548 12.9085C21.4224 13.1032 22.5545 13.2191 23.7449 13.2191C27.6808 13.2191 30.9261 12.0742 32.9131 10.3053V11.4458C32.3933 13.7291 28.4143 15.6379 23.7449 15.6379C23.3228 15.6379 23.2123 15.6198 22.802 15.59ZM24.9763 30.864C24.5714 30.8944 24.1616 30.9149 23.7449 30.9149C23.381 30.9149 23.3282 30.8997 22.9732 30.8763V29.0144C23.3272 29.0374 23.3791 29.0521 23.7449 29.0521C24.1645 29.0521 24.5724 29.0311 24.9763 29.0012V30.864ZM24.9763 27.2318C24.5714 27.2627 24.1616 27.2837 23.7449 27.2837C23.381 27.2837 23.3282 27.2675 22.9732 27.2451V25.1319C23.3272 25.1548 23.3791 25.17 23.7449 25.17C24.1337 25.17 24.5122 25.1514 24.8863 25.1265C24.8961 25.373 24.9269 25.615 24.9763 25.8532V27.2318V27.2318ZM25.2394 23.3326C24.7494 23.3762 24.2515 23.4021 23.7449 23.4021C23.381 23.4021 23.3282 23.3869 22.9737 23.3635V21.2512C23.3277 21.2732 23.3796 21.2889 23.7449 21.2889C24.9445 21.2889 26.0835 21.1705 27.156 20.9715C26.2689 21.6601 25.6121 22.4587 25.2394 23.3326ZM36.2235 38.2047C31.1829 38.2047 26.7565 36.0128 26.7066 33.5034L26.7222 33.0349H26.7491C28.7117 34.864 32.181 36.0602 36.2235 36.0602C40.2646 36.0602 43.7329 34.8645 45.696 33.0349H45.7263L45.7409 33.4599C45.7405 35.9873 41.2935 38.2047 36.2235 38.2047ZM10.6985 18.424C10.6163 18.3257 10.5522 18.1326 10.5063 17.8445H9.17752C9.16725 18.4778 9.44307 18.9258 10.004 19.1884C10.3224 19.3346 10.8051 19.4329 11.4516 19.4833V20.1655H11.9289V19.4765C12.438 19.4496 12.8772 19.3557 13.2479 19.1958C13.8548 18.9356 14.159 18.517 14.159 17.9413C14.159 17.5046 13.9384 17.1662 13.4973 16.9266C13.2298 16.7828 12.707 16.617 11.9289 16.4292V15.1234C12.2532 15.1396 12.4767 15.2286 12.6004 15.3909C12.6713 15.4848 12.7202 15.633 12.7461 15.8365H14.0411C14.0211 15.2887 13.7355 14.8916 13.1833 14.6471C12.8796 14.494 12.461 14.4026 11.9289 14.3727V13.9101H11.4516V14.3659C11.1171 14.3845 10.8618 14.4123 10.6887 14.4515C10.4026 14.5131 10.1439 14.6256 9.91109 14.7874C9.73063 14.9131 9.59028 15.0628 9.49002 15.2364C9.38976 15.4105 9.33988 15.6032 9.33988 15.8154C9.33988 16.1377 9.4685 16.4135 9.72623 16.6419C9.98396 16.8698 10.4266 17.0483 11.0535 17.177L11.4521 17.2591V18.7224C11.078 18.6764 10.8271 18.5771 10.6985 18.424ZM11.9289 17.3716C12.2018 17.4425 12.395 17.511 12.508 17.577C12.6997 17.6914 12.795 17.847 12.795 18.0431C12.795 18.3018 12.6933 18.4827 12.4884 18.5884C12.372 18.6475 12.1852 18.6891 11.9289 18.7116V17.3716ZM10.92 16.1612C10.7136 16.0492 10.6099 15.8976 10.6099 15.7054C10.6099 15.5293 10.6789 15.3909 10.8168 15.2887C10.9542 15.1875 11.166 15.1342 11.4521 15.1293V16.3328C11.212 16.2805 11.0344 16.2233 10.92 16.1612ZM35.1906 26.1197C35.1085 26.0214 35.0444 25.8288 34.9984 25.5407H33.6697C33.6599 26.174 33.9353 26.622 34.4962 26.8846C34.8146 27.0308 35.2973 27.1291 35.9438 27.1795V27.8613H36.4216V27.1727C36.9302 27.1448 37.3699 27.0509 37.7406 26.8915C38.3475 26.6308 38.6512 26.2122 38.6512 25.6366C38.6512 25.1998 38.4301 24.8624 37.989 24.6223C37.7215 24.478 37.1987 24.3122 36.4211 24.1254V22.8191C36.7453 22.8348 36.9683 22.9243 37.0921 23.0866C37.164 23.1801 37.2119 23.3287 37.2383 23.5322H38.5328C38.5133 22.9835 38.2272 22.5873 37.6755 22.3428C37.3718 22.1897 36.9537 22.0978 36.4211 22.068V21.6053H35.9438V22.0611C35.6093 22.0802 35.355 22.1085 35.1809 22.1467C34.8953 22.2083 34.6361 22.3203 34.4033 22.4832C34.2228 22.6084 34.0825 22.7585 33.9822 22.9316C33.8824 23.1057 33.8321 23.2989 33.8321 23.5111C33.8321 23.8329 33.9607 24.1088 34.2184 24.3372C34.4757 24.5655 34.9178 24.744 35.5447 24.8717L35.9433 24.9543V26.4176C35.5697 26.3726 35.3188 26.2728 35.1906 26.1197ZM36.4211 25.0678C36.6935 25.1392 36.8867 25.2072 37.0001 25.2732C37.1918 25.3876 37.2872 25.5436 37.2872 25.7402C37.2872 25.998 37.1855 26.1799 36.9811 26.285C36.8642 26.3442 36.6774 26.3853 36.4216 26.4083V25.0678H36.4211ZM35.4117 23.8574C35.2048 23.7459 35.1021 23.5943 35.1021 23.4021C35.1021 23.226 35.1706 23.0866 35.3085 22.9854C35.4464 22.8832 35.6577 22.8304 35.9433 22.826V24.0286C35.7042 23.9762 35.5271 23.919 35.4117 23.8574ZM22.781 8.09184C22.6988 7.99354 22.6347 7.80037 22.5888 7.51232H21.26C21.2502 8.14564 21.5261 8.59361 22.087 8.85574C22.4049 9.00197 22.8871 9.10027 23.5341 9.15064V9.83287H24.0114V9.14428C24.52 9.11641 24.9597 9.02349 25.3304 8.86308C25.9373 8.60192 26.2415 8.18427 26.2415 7.60817C26.2415 7.17194 26.0214 6.83351 25.5798 6.59339C25.3118 6.44961 24.7895 6.28333 24.0114 6.09651V4.79075C24.3357 4.80738 24.5596 4.89589 24.6829 5.05875C24.7543 5.15216 24.8027 5.30083 24.8286 5.50427H26.1227C26.1031 4.95556 25.817 4.55943 25.2653 4.3149C24.9616 4.16183 24.5435 4.07037 24.0109 4.04054V3.57741H23.5336V4.0337C23.1986 4.05179 22.9443 4.08016 22.7702 4.11928C22.4851 4.1809 22.2254 4.2924 21.9926 4.45477C21.8122 4.58046 21.6723 4.73059 21.5715 4.90421C21.4718 5.07782 21.4214 5.271 21.4214 5.48324C21.4214 5.80602 21.55 6.08135 21.8078 6.30925C22.065 6.53813 22.5071 6.71614 23.1346 6.84379L23.5336 6.92643V8.38968C23.16 8.34419 22.9086 8.24492 22.781 8.09184ZM24.0114 7.03941C24.2838 7.11032 24.477 7.17927 24.5905 7.2453C24.7817 7.35924 24.8775 7.51525 24.8775 7.71136C24.8775 7.96958 24.7753 8.15102 24.5714 8.25616C24.4545 8.31534 24.2677 8.35642 24.0114 8.37941V7.03941ZM23.002 5.82949C22.7951 5.71701 22.6924 5.5654 22.6924 5.37321C22.6924 5.19764 22.7609 5.05826 22.8993 4.95654C23.0372 4.8553 23.2485 4.80151 23.5341 4.79711V6.00066C23.2945 5.94784 23.1174 5.8916 23.002 5.82949Z" fill="var(--color-pri)"></path></svg>{{$route.meta.title}}</span>
      <input type="checkbox" class="selectAll" v-model="selectAll" @click="setAgSelect" label="全選">
      <input type="radio" v-model="daterange" value="半年">
      <input type="radio" v-model="daterange" value="一年">
      <input type="radio" v-model="daterange" value="自訂">
      <template v-if="daterange==='自訂'">
        <vue-ctk-date-time-picker :range="true" v-model="range"
        :color="'var(--color-pri)'"
        :no-label="true"
        id="records2"
        :no-shortcuts="true"
        :input-size="'sm'"
        :label="'選取時間範圍'"
        :format="'YYYY-MM-DD'"
        :formatted="'YYYY-MM-DD'"/>
      </template>
      <button class="exportBtn print2" :style="{marginLeft: 'auto', backgroundColor: 'var(--color-pri)'}" @click="exportTable">匯出</button>
      <button class="printBtn" @click="printSingle('printReward')" :style="{marginRight: '20px'}" :disabled="rewardFiltered.length===0">列印</button>
    </div>
    <div class="header">
      <button class="exportBtn print2" :style="{marginLeft: 'auto'}" @click="exportTable2" v-if="agencySelectName">匯出</button>
      <button class="printBtn print2" :style="{marginRight: '20px'}"  @click="printSingle('SubPrintReward')" v-if="agencySelectName">列印</button>
      <!-- <input type="radio" label=""> -->
    </div>
    <div class="content" :style="{overflowY: 'auto'}">
      <table>
        <thead>
          <tr :style="{borderBottom: '1px solid #FFFFFF'}">
            <th :style="{width: `${widths[0]}px`}" rowspan="2"></th>
            <th :style="{width: `${widths[1]}px`, borderRight: '1px solid #FFFFFF', textAlign: 'start'}">統編</th>
            <th :style="{width: `${widths[2]+widths[3]+widths[4]+widths[5]}px`, borderRight: '1px solid #FFFFFF'}" colspan="4">團體票種</th>
            <th :style="{width: `${widths[6]}px`, borderRight: '1px solid #FFFFFF'}" rowspan="2">{{contract?'合約':'付費'}}票數</th>
            <th :style="{width: `${widths[7]}px`, borderRight: '1px solid #FFFFFF'}" rowspan="2">非團體票數</th>
            <th :style="{width: `${widths[8]}px`, borderRight: '1px solid #FFFFFF'}" rowspan="2">總人次</th>
            <th :style="{width: 'inherit', textAlign: 'start'}" rowspan="2">門票總金額</th>
          </tr>
          <tr>
            <th :style="{width: `${widths[1]}px`, borderRight: '1px solid #FFFFFF', textAlign: 'start'}">代理商</th>
            <th :style="{width: `${widths[2]}px`}">團(平)</th>
            <th :style="{width: `${widths[3]}px`}">團(假)</th>
            <th :style="{width: `${widths[4]}px`}">優惠</th>
            <th :style="{width: `${widths[5]}px`, borderRight: '1px solid #FFFFFF'}">其他</th>
          </tr>
        </thead>
        <tbody>
          <tr :style="{height: '64px'}"
          v-for="({
            name,
            ID,
            ticket1, ticket2, ticket3, ticketGroupOther, ticketAllOther, ticketAllGroup, count, re1
          }, i) in reward" :key="`team-${i}`" @click="agencySelect=ID" :class="agencySelect===ID? 'selected': ''" >
            <td :style="{width: `${widths[0]}px`}"><input type="checkbox" v-model="agSelect" :value="ID"></td>
            <td :style="{width: `${widths[1]}px`, textAlign: 'start'}">{{ID}}<br>{{name}}</td>
            <td :style="{width: `${widths[2]}px`}">{{ticket1?ticket1:'-'}}</td>
            <td :style="{width: `${widths[3]}px`}">{{ticket2?ticket2:'-'}}</td>
            <td :style="{width: `${widths[4]}px`}">{{ticket3?ticket3:'-'}}</td>
            <td :style="{width: `${widths[5]}px`}">{{ticketGroupOther?ticketGroupOther:'-'}}</td>
            <td :style="{width: `${widths[6]}px`, color: '#E37878', fontWeight: 900}">{{ticketAllGroup?ticketAllGroup:'-'}}</td>
            <td :style="{width: `${widths[7]}px`, color: 'var(--color-checked)', fontWeight: 900}">{{ticketAllOther?ticketAllOther:'-'}}</td>
            <td :style="{width: `${widths[8]}px`, color: 'var(--color-checked)', fontWeight: 900}">{{count}}</td>
            <td :style="{width: 'inherit', color: '#E37878', fontWeight: 900, textAlign: 'start'}">{{formatDollarInt(re1)}}</td>
          </tr>
        </tbody>
      </table>
      <table id="tableprint" :style="{display: 'none'}">
        <thead>
          <tr>
            <th :style="{width: `${widths[0]}px`}">統編</th>
            <th :style="{width: `${widths[1]}px`, textAlign: 'start'}">名稱</th>
            <th :style="{width: `${widths[2]}px`}">團(平)</th>
            <th :style="{width: `${widths[3]}px`}">團(假)</th>
            <th :style="{width: `${widths[4]}px`}">優惠</th>
            <th v-for="({id, name}, i) in grouptickets" :key="`ticketid-${i}`" :style="{width: `${widths[5]}px`}">{{id}}|{{name.replace(/入園清潔費-/i, '')}}</th>
            <th :style="{width: `${widths[6]}px`}">{{contract?'合約':'團體'}}票數</th>
            <th :style="{width: `${widths[7]}px`}">非團體票數</th>
            <th :style="{width: `${widths[8]}px`}">總人次</th>
            <th :style="{width: 'inherit', textAlign: 'start'}">門票總金額</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(data, i) in reward.filter(({ID}) => agSelect.includes(ID))" :key="`team-${i}`">
            <td :style="{width: `${widths[0]}px`}">{{data.ID}}</td>
            <td :style="{width: `${widths[1]}px`, textAlign: 'start'}">{{data.name}}</td>
            <td :style="{width: `${widths[2]}px`}">{{data.ticket1?data.ticket1:'-'}}</td>
            <td :style="{width: `${widths[3]}px`}">{{data.ticket2?data.ticket2:'-'}}</td>
            <td :style="{width: `${widths[4]}px`}">{{data.ticket3?data.ticket3:'-'}}</td>
            <th v-for="({id}, i) in grouptickets" :key="`ticketid-${i}`" :style="{width: `${widths[5]}px`}">{{data[id]?data[id]:'-'}}</th>
            <td :style="{width: `${widths[6]}px`}">{{data.ticketAllGroup?data.ticketAllGroup:'-'}}</td>
            <td :style="{width: `${widths[7]}px`}">{{data.ticketAllOther?data.ticketAllOther:'-'}}</td>
            <td :style="{width: `${widths[8]}px`}">{{data.count}}</td>
            <td :style="{width: 'inherit', color: '#E37878', fontWeight: 900, textAlign: 'start'}">{{formatDollarInt(data.re1)}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="agencySelect" class="agencySelect">
      <template>
      <div v-for="({
        _id: date,
        total,
        ticket1, ticket2, ticket3, ticketGroupOther, ticketAllGroup,
        re1, re2,
        invoices
      }, i) in details" :key="`detail-${i}`" class="groupdiv">
        <div class="gh">
          <div>日期: {{toDate(date)}}</div>
        </div>
        <div class="gb">
          <div><span>總消費</span>
          <span :style="{color: 'var(--color-confirm)', fontWeight: 'bold'}"
          >{{formatDollarInt(total)}} <button @click="groupSelect=invoices;groupDate=date"></button></span></div>
          <div><span>門票</span>
            <span :style="{marginRight: '26px'}">{{formatDollarInt(re1)}}</span></div>
          <div><span>二消</span>
            <span :style="{marginRight: '26px'}">{{formatDollarInt(re2)}}</span></div>
          <hr>
          <div>門票詳情</div>
          <table>
            <tr>
              <th>品項</th>
              <th>人數</th>
              <th>合計</th>
            </tr>
            <tr>
              <th>團(平)</th>
              <td>{{ticket1?ticket1:'-'}}</td>
              <td :style="{color: '#E37878', fontWeight: '500', fontSize: '24px'}" rowspan="6">{{ticketAllGroup?ticketAllGroup:'-'}}</td>
            </tr>
            <tr>
              <th>團(假)</th>
              <td>{{ticket2?ticket2:'-'}}</td>
            </tr>
            <tr>
              <th>優惠</th>
              <td>{{ticket3?ticket3:'-'}}</td>
            </tr>
            <tr>
              <th>其他</th>
              <td>{{ticketGroupOther?ticketGroupOther:'-'}}</td>
            </tr>
          </table>
        </div>
      </div>
 <!-- :style="{display: 'none'}" -->
      <table id="tableprint2" :style="{display: 'none'}">
        <thead>
          <tr>
            <th :style="{width: `${widths[0]}px`}">項次</th>
            <th :style="{width: `${widths[1]}px`, textAlign: 'start'}">日期</th>
            <th :style="{width: `${widths[2]}px`}">團(平)</th>
            <th :style="{width: `${widths[3]}px`}">團(假)</th>
            <th :style="{width: `${widths[4]}px`}">優惠</th>
            <th v-for="({id, name}, i) in grouptickets" :key="`ticketid-${i}`" :style="{width: `${widths[5]}px`}">{{id}}|{{name.replace(/入園清潔費-/i, '')}}</th>
            <th :style="{width: `${widths[6]}px`}">{{contract?'合約':'團體'}}票數</th>
            <th :style="{width: `${widths[7]}px`}">非團體票數</th>
            <th :style="{width: `${widths[8]}px`}">總人次</th>
            <th :style="{width: 'inherit', textAlign: 'start'}">門票總金額</th>
            <th :style="{width: 'inherit', textAlign: 'start'}">二消總金額</th>
            <th :style="{width: 'inherit', textAlign: 'start'}">總金額</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(data, i) in details" :key="`team-${i}`">
            <td :style="{width: `${widths[0]}px`}">{{i+1}}</td>
            <td :style="{width: `${widths[1]}px`, textAlign: 'start'}">{{toDate(data.date)}}</td>
            <td :style="{width: `${widths[2]}px`}">{{data.ticket1?data.ticket1:'-'}}</td>
            <td :style="{width: `${widths[3]}px`}">{{data.ticket2?data.ticket2:'-'}}</td>
            <td :style="{width: `${widths[4]}px`}">{{data.ticket3?data.ticket3:'-'}}</td>
            <th v-for="({id}, i) in grouptickets" :key="`ticketid-${i}`" :style="{width: `${widths[5]}px`}">{{data[id]?data[id]:'-'}}</th>
            <td :style="{width: `${widths[6]}px`}">{{data.ticketAllGroup?data.ticketAllGroup:'-'}}</td>
            <td :style="{width: `${widths[7]}px`}">{{data.ticketAllOther?data.ticketAllOther:'-'}}</td>
            <td :style="{width: `${widths[8]}px`}">{{data.count}}</td>
            <td :style="{width: 'inherit', color: '#E37878', fontWeight: 900, textAlign: 'start'}">{{formatDollarInt(data.re1)}}</td>
            <td :style="{width: 'inherit', color: '#E37878', fontWeight: 900, textAlign: 'start'}">{{formatDollarInt(data.re2)}}</td>
            <td :style="{width: 'inherit', color: '#E37878', fontWeight: 900, textAlign: 'start'}">{{formatDollarInt(data.total)}}</td>
          </tr>
        </tbody>
      </table>
      </template>
    </div>
    <dialogInvoices
      v-if="groupSelect"
      :width="566"
      :height="900"
      :date="toDate(groupDate)"
      :id="groupSelect.groupID"
      :leader="groupSelect.leaderName"
      :show="!!groupSelect"
      :showPrint="false"
      :name="agencySelectName"
      @detail="goToInvoices(groupSelect)"
      @close="groupSelect=null">
      <table class="invoicetable">
        <thead>
          <th>發票號碼</th>
          <th>總銷售淨額</th>
          <th>發票總金額</th>
          <th>(總)發票稅額</th>
        </thead>
        <tbody :style="{maxHeight: '700px'}">
          <tr v-for="({
            invoiceStart, invoiceAmounts, totalInvoiceTax, totalSalesAmounts
          }, i) in groupSelect.filter(e => e.invoiceStart)" :key="`invoice-${i}`" @click="openPage(invoice)">
            <td>{{invoiceStart}}</td>
            <td>{{formatDollar(totalSalesAmounts)}}</td>
            <td>{{formatDollar(invoiceAmounts)}}</td>
            <td>{{formatDollar(totalInvoiceTax)}}</td>
          </tr>
        </tbody>
      </table>
    </dialogInvoices>
    <printRewardv2 :records="rewardFiltered" v-show="rewardFiltered&&rewardFiltered.length>0"/>
    <!-- <printReward :records="reward.filter(({ID}) => agSelect.includes(ID))" v-if="print" @close="print=false"/> -->
    <!-- <printRewardList :name="agencySelectName" :records="details" v-if="agencySelectName" v-show="printAg" @close="printAg=false"/> -->
    <printRewardList :name="agencySelectName" :records="details"/>
    <!-- <exportInvoices v-if="agencySelect" :agency="agencySelect"/> -->
  </div>
</div>
</template>

<script>
import XLSX from 'xlsx'
import printRewardv2 from './printTeam.vue'
import printRewardList from './SubPrintTeam.vue'
// import exportInvoices from './partial/exportInvoices.vue'
// import printRewardList from './printRewardlist_v2.vue'
// import printReward from './printReward_v2.vue'
import dialogInvoices from '../../components/dialogInvoices_v2.vue'
// import L1 from '../../components/layout/L1.vue'
// import dialogAbs from '../components/dialogAbs'
import { getapi } from '../../store/fetch'
import stringifyCss from './print.js'
export default {
  name: 'PaymentRecord',
  components: {
    dialogInvoices,
    printRewardList,
    // printReward,
    printRewardv2
    // ,
    // L1
    // dialogAbs
    // printReward,
    // printRewardAg,
    // exportInvoices
  },
  data () {
    return {
      widths: [
        50,
        200,
        83,
        83,
        83,
        83,
        114,
        115,
        123
      ],
      range: {
        start: null,
        end: null
      },
      grouptickets: [],
      groupDate: null,
      daterange: '半年',
      unpay: true,
      selectAll: false,
      agSelect: [],
      reward: [],
      sheetfill: null,
      agencySelect: null,
      groupSelect: null,
      sheetID: null,
      invoices: [],
      showMode: 'first',
      print: false,
      printAg: false,
      month: this.moment().format('YYYYMM'),
      details: []
    }
  },
  computed: {
    rewardFiltered () {
      return this.reward.filter(({ ID }) => this.agSelect.includes(ID))
    },
    agencySelectName () {
      if (this.agencySelect) {
        const elem = this.reward.find(({ ID }) => ID === this.agencySelect)
        if (elem) {
          return elem.name
        }
      }
      return null
    },
    contract () {
      if (this.$route.name === 'SpecialAgencyRecord') {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    async agencySelect () {
      if (this.agencySelect) {
        const details = await getapi(`consumeRecords/agencyInvoice/byDay/${this.agencySelect}?${new URLSearchParams(
          this.daterange === '半年' ? {
            start: this.moment().add(-6, 'month').startOf('day').toISOString(),
            end: this.moment().endOf('day').toISOString()
          }
          : this.daterange === '一年' ? {
            start: this.moment().add(-1, 'year').startOf('day').toISOString(),
            end: this.moment().endOf('day').toISOString()
          } : this.daterange === '自訂時間' ? {
            start: this.moment(this.range.start).startOf('day').toISOString(),
            end: this.moment(this.range.end).endOf('day').toISOString()
          } : {
            start: this.moment(this.range.start).startOf('day').toISOString(),
            end: this.moment(this.range.end).endOf('day').toISOString()
          }
        )}`)
        details.sort((a, b) => this.moment(a._id).isBefore(this.moment(b._id)) ? -1 : 1)
        this.details = details
      }
    },
    agSelect () {
      if (this.agSelect === this.reward.map(e => e._id)) {
        this.selectAll = true
      } else {
        this.selectAll = false
      }
    },
    async daterange () { await this.getTeams() },
    async range () { await this.getTeams() },
    async groupSelect () {
      // if (this.groupSelect) {
      //   const stringsearch = new URLSearchParams({ invoices: this.groupSelect.invoices })
      //   // console.log(stringsearch)
      //   this.invoices = await getapi(`consumeRecords/invoices?${stringsearch}`)
      // }
    }
  },
  async mounted () {
    const grouptickets = await getapi('products/grouptickets')
    this.grouptickets = grouptickets
    await this.getTeams()
    this.agencySelect = this.reward[0]
  },
  methods: {
    printSingle (page) {
      setTimeout(() => {
        const css = stringifyCss[page]
        const selector = '#preview.' + page
        const content = document.querySelector(selector)
        const ht = document.createElement('html')
        const head = document.createElement('head')
        const body = document.createElement('body')
        const title = document.createElement('title')
        title.innerText = '代理商消費紀錄統計表'
        const div = document.createElement('div')
        div.id = 'preview'
        div.style.width = '297mm'
        div.style.marginInline = 'auto'
        div.innerHTML = content.innerHTML
        body.appendChild(div)
        head.appendChild(title)
        const style = document.createElement('style')
        style.media = 'print'
        style.appendChild(document.createTextNode(css))
        const style1 = document.createElement('style')
        style1.media = 'screen'
        style1.appendChild(document.createTextNode(css + 'body{margin:auto;width:297mm;background: #999999;}'))
        head.appendChild(style)
        head.appendChild(style1)
        ht.appendChild(head)
        ht.appendChild(body)
        const printWin = window.open('', '', '')
        printWin.document.write(`<html>${ht.innerHTML}</html>`)
        printWin.document.close()
        setTimeout(() => {
          printWin.print()
          this.printshow = false
        }, 500)
        return false
      }, 300)
    },
    async exportTable2 () {
      if (this.agencySelect) {
        const table = document.getElementById('tableprint2') // tableprint2 printTeamTable
        const name0 = `${this.agencySelectName}消費紀錄`
        const name = `${
          this.daterange === '半年'
          ? `${this.toDate(this.moment().add(-6, 'month'))}~${this.toDate(this.moment())}`
          : this.daterange === '一年'
          ? `${this.toDate(this.moment().add(-12, 'month'))}~${this.toDate(this.moment())}`
          : `${this.toDate(this.moment(this.range.start))}~${this.toDate(this.moment(this.range.end))}`
        }`
        console.log('sheetName', name)
        await XLSX.utils.table_to_sheet(table, {
          dateNF: 's',
          sheet: name,
          raw: true
        })
        // const jsondata = await XLSX.utils.sheet_to_json(sheet)
        // console.log('sheet', sheet)
        const workbook = await XLSX.utils.table_to_book(table, { dateNF: 's', sheet: name, raw: true })
        XLSX.writeFile(workbook, `${name0}-${name}.xlsx`)
      }
    },
    async exportTable () {
      const table = document.getElementById('tableprint')
      const name = `代理商消費紀錄${
        this.daterange === '半年'
        ? `${this.toDate(this.moment().add(-6, 'month'))}~${this.toDate(this.moment())}`
        : this.daterange === '一年'
        ? `${this.toDate(this.moment().add(-12, 'month'))}~${this.toDate(this.moment())}`
        : `${this.toDate(this.moment(this.range.start))}~${this.toDate(this.moment(this.range.end))}`
      }`
      await XLSX.utils.table_to_sheet(table, {
        dateNF: 's',
        sheet: name,
        raw: true
      })
      // const jsondata = await XLSX.utils.sheet_to_json(sheet)
      // console.log('sheet', sheet)
      const workbook = await XLSX.utils.table_to_book(table, { dateNF: 's', sheet: name, raw: true })
      XLSX.writeFile(workbook, `${name}.xlsx`)
    },
    setAgSelect (event) {
      if (event.target.checked) {
        this.agSelect = this.reward.map(e => e.ID)
      } else {
        this.agSelect = []
      }
    },
    async getTeams () {
      if (this.daterange === '半年') {
        const reward = await getapi(`consumeRecords/agencyInvoice?${new URLSearchParams({
          start: this.moment().add(-6, 'month').startOf('day').toISOString(),
          end: this.moment().endOf('day').toISOString(),
          contract: this.contract ? 1 : 0
        })}`)
        this.reward = reward
      } else if (this.daterange === '一年') {
        const reward = await getapi(`consumeRecords/agencyInvoice?${new URLSearchParams({
          start: this.moment().add(-12, 'month').startOf('day').toISOString(),
          end: this.moment().endOf('day').toISOString(),
          contract: this.contract ? 1 : 0
        })}`)
        this.reward = reward
      } else if (this.daterange === '自訂' && this.range.start && this.range.end) {
        const reward = await getapi(`consumeRecords/agencyInvoice?${new URLSearchParams({
          start: this.moment(this.range.start).startOf('day').toISOString(),
          end: this.moment(this.range.end).endOf('day').toISOString(),
          contract: this.contract ? 1 : 0
        })}`)
        this.reward = reward
      }
    }
  }
}
</script>
<style lang="scss">
.PaymentRecord {
  overflow-y: hidden;
    #records2-wrapper {
      width: 200px;
      height: 40px;
      justify-self: flex-start;
      text-align: start;
      margin: 0;
    }
    #records2-input {
      height: 40px;
      width: 200px;
      font-size: 13px;
    }
    .datepicker {
      transform: translateX(-200px);
    }
  .agencySelect {
    .back {
      right: -9px;
    }
  }
  .content {
    thead > tr {
      height: 38px;
    }
    thead > tr > th {
      font-size: 18px;
      font-weight: 400;
      color: #000000;
    }
    .back {
      top: -90px;
      left: -9px;
    }
    .dialogbox {
      transform: translateY(-30%);
      height: 275px;
      .headerBox {
        height: 55px;
      }
      &> div:not(.headerBox) {
        margin-right: 0!important;
        height: calc(100% - 64px);
      }
      &> div:not(.headerBox) > div {
        margin-block: 30px;
        margin-inline: auto;
        align-items: center;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
thead tr {
  background-color: var(--color-infobox);
  &:nth-child(1) {
    border-bottom: 1px solid #FFFFFF;
  }
}
table {
  border-collapse: collapse;
  width: 100%;
}
input[type=radio]:not(.grouptype) {
  margin: 0;
  appearance: none;
  width: fit-content;
  padding-inline: 8px;
  height: 40px;
  background: #C4C4C4;
  border-radius: 3px;
  font-weight: 400;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  &:checked {
    background-color: var(--color-checked);
  }
  &::before{
    content: attr(value);
    line-height: 18px;
    text-align: center;
  }
}
.grouptype {
  width: 95px;
  height: 40px;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  appearance: none;
  color: #FFFFFF;
  background-color: var(--color-cancel);
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: #FFFFFF;
  &:checked {
    background-color: var(--color-checked);
  }
  &::after {
    content: attr(label);
  }
  &:nth-child(1) {
    margin-left: 30px;
  }
}
.fillsheetContent {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: 0.1em;
  color:var(--color-letter);
  input {
    margin-bottom: 15px;
  width: 300px;
  height: 40px;
  border: 1px solid var(--color-border);
  box-sizing: border-box;
  border-radius: 3px;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: 0.1em;
  color:var(--color-letter);
  text-align: center;
  }
}
.btns{
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 28px;
  button {
    &:disabled {
      filter: contrast(.5);
    }
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    width: 100px;
    height: 35px;
    line-height: 35px;
    border-radius: 20px;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    &.confirm {
      background: #E37878;
    }
    &.cancel {
      background: #B8B8B8;
    }
  }
}
.unpay {
  width: 120px;
  height: 40px;
  appearance: none;
  border-radius: 3px;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  background-color: var(--color-cancel);
  &:checked {
    background-color: var(--color-saveAs);
  }
  &::after {
    content: attr(label);
  }
}
.selectAll {
  width: 89px;
  height: 40px;
  background-color: var(--color-confirm);
  appearance: none;
  border-radius: 3px;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  &::before {
    box-sizing: border-box;
    border: none;
    content: '';
    display: inline-block;
    width: 25px;
    height: 25px;
    background-color: #FFFFFF;
    border-radius: 3px;
  }
  &:checked::before {
    // background-color: transparent;
    // background-color: var(--color-confirm);
    mask-image: url(/checkmark2.svg);
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: contain;
  }
  &::after {
    content: attr(label);
  }
}
.fillsheet {
  width: 30px;
  height: 30px;
  background-color: var(--color-checked);
  mask-image: url(/sheet.svg);
  border: none;
  mask-repeat: no-repeat;
  mask-position: center;
}
.printBtn {
  border: none;
  width: 100px;
  height: 35px;
  border-radius: 20px;
  box-sizing: border-box;
  background-color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 35px;
  letter-spacing: 0.1em;
  background-color: var(--color-pri);
  color: #FFFFFF;
  gap: 6px;
  &::before {
    content: '';
    display: inline-flex;
    width: 25px;
    height: 22px;
    mask-image: url(/print.svg);
    background-color: #FFFFFF;
    mask-repeat: no-repeat;
  }
  &:disabled {
    filter: contrast(.5);
  }
  &.print2 {
    background-color: var(--color-checked);
  }
}
.exportBtn {
  border: none;
  width: 100px;
  height: 35px;
  border-radius: 20px;
  box-sizing: border-box;
  background-color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 35px;
  letter-spacing: 0.1em;
  background-color: var(--color-pri);
  color: #FFFFFF;
  gap: 6px;
  &::before {
    content: '';
    display: inline-flex;
    width: 25px;
    height: 25px;
    mask-image: url(/export.svg);
    background-color: #FFFFFF;
    mask-repeat: no-repeat;
  }
  &.print2 {
    background-color: var(--color-checked);
  }
}
.invoicetable {
  td, th {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    letter-spacing: 0.1em;
    text-align: end;
    &:nth-child(1) {
      padding-left: 20px;
      text-align: start;
    }
    &:last-child {
      padding-right: 20px;
    }
  }
  td { color: var(--color-letter);  }
  th { color: #000000; }
}
.groupdiv {
  border-radius: 10px;
  position: relative;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  width: 297px;
  height: 460px;
  box-sizing: border-box;
  &>div {
    box-sizing: border-box;
  }
}
.gh {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  letter-spacing: 0.1em;
  border-radius: 10px 10px 0 0;
  position: relative;
  background-color: var(--color-checked);
  color: #FFFFFF;
  height: 45px;
  display: flex;
  flex-direction: column;
  padding-inline: 17px;
  justify-content: space-evenly;
  &>div {
    display: flex;
  }
}
.gb {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: var(--color-letter);
  height: 375px;
  padding-top: 16px;
  &>div {
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-inline: 26px;
  }
  hr {
    margin-top: 22px;
    margin-inline: 19px;
    margin-bottom: 16px;
  }
  table {
    margin-inline: 26px;
    border-collapse: collapse;
    background-color: #B8B8B8;
    border: 1px solid #B8B8B8;
    display: table;
    // gap: 1px;
    width: 251px;
    tr {
      border-bottom: 1px solid #B8B8B8;
      &:last-child {
        border: none;
      }
    }
    th {
      color: #999999;
      &:last-child {
        color: #E37878;
      }
    }
    td {
      color: #5E5E5E;
    }
    td, th {
      background-color: #FFFFFF;
      line-height: 34px;
      border-inline: 1px solid var(--color-border);
      align-items: center;
      font-family: Noto Sans TC;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      letter-spacing: 0.1em;
      justify-content: center;
      &:last-child {
        border-right: none;
      }
    }
  }
  button {
    width: 20px;
    height: 21px;
    background-color: transparent;
    box-sizing: border-box;
    border: none;
    mask-image: url(/list.svg);
    background-color: var(--color-checked);
    mask-size: contain;
    mask-position: center;
    mask-repeat: no-repeat;
  }
  span {
    display: inline-flex;
    align-items: center;
    gap: 5px;
  }
}
.gf {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  letter-spacing: 0.1em;
  border-radius: 0 0 10px 10px;
  background-color: var(--color-checked);
  position: relative;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-inline: 17px;
  color: #FFFFFF;
}
.agencySelect {
  display: flex;
  flex-wrap: wrap;
  padding: 19px 27px;
  gap: 18px;
  position: relative;
  overflow-y: auto;
    &::-webkit-scrollbar {
      width: 7px;
      background-color: #F5F5F5;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 20px;
      box-shadow: inset 0 0 6px #0000004d;
      background-color: var(--color-pri);
    }
    &::-webkit-scrollbar-track {
      border: none;
      border-radius: 20px;
      background-color: #d8d8d8;
      border: 2px solid #FFFFFF!important;
    }
}
.PaymentRecord {
  display: grid;
  grid-template-columns: 1142px 1fr;
  grid-template-rows: 89px calc(100vh - 90px);
  padding-inline: 9px 9px!important;
  height: 100vh;
  .content {
    position: relative;
    height: calc(100vh - 90px);
    border-right: 1px solid var(--color-border);
  }
 }

.header {
  &:nth-child(1) {
    border-right: 1px solid var(--color-border);
  }
  height: 89px;
  display: flex;
  align-items: center;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 36px;
  letter-spacing: 0.15em;
  border-bottom: 1px solid var(--color-border);
  color: var(--color-pri);
  gap: 10px;
  span {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    min-width: fit-content;
  }
  select {
    width: 90px;
    height: 40px;
    border: 1px solid var(--color-border);
    border-radius: 3px;
    box-sizing: border-box;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    letter-spacing: 0.1em;
    color: var(--color-checked);
    padding-inline: 13px;
  }
}
tr.selected {
  background-color: var(--color-infobox);
}
.content {
td {
font-family: Roboto;
font-style: normal;
font-weight: normal;
font-size: 20px;
letter-spacing: 0.1em;
color: var(--color-letter);
}
th {
font-family: Roboto;
font-style: normal;
font-weight: normal;
font-size: 18px;
letter-spacing: 0.1em;
color: #000000;
}
th, td {
  padding-inline: 5px;
  text-align: center;
  box-sizing: border-box;
  &:nth-child(1)>input[type=checkbox] {
    background-color: #FFFFFF;
    border: 1px solid var(--color-checked);
    box-sizing: border-box;
    border-radius: 5px;
    appearance: none;
    width: 30px;
    height: 30px;
    position: relative;
    &:checked::before {
      content: '';
      position: absolute;
      top: 2px;
      left: 2px;
      display: inline-block;
      bottom: 2px;
      right: 2px;
      background-color: var(--color-checked);
      mask-image: url(/checkmark.svg);
      mask-size: 22px;
      mask-repeat: no-repeat;
      mask-position: center;
    }
  }
}
tr:hover {
  th, td {
    // border-right: 1px solid #FFFFFF;
  }
}
}
</style>
